module.exports = __webpack_public_path__ + "img/2019-11-12-wap.9d27a6fc.png";